import { Box } from '@mui/material';
const LoaderText = () => {
    return (
        <Box
            sx={{
                px: 2,
                py: 1.5,
                width: '100%',
                height: '80%',
                position: 'absolute',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                zIndex: 9999,
            }}
        >            <span className="loader"></span>

        </Box>
    );
};

export default LoaderText;
